import { useCreateAgencyWithUserMutation } from '@anytag/graphql';
import { UNEXPECTED_ERROR } from '@anytag/shared-constants';
import { useUpdateDocumentTitle, useQueryHelper } from '@anytag/shared-hooks';
import { Header } from '@anytag/shared-molecules';
import { AgencyFormValues, AgencyForm } from '@anytag/shared-organisms';

export const AddAgency = () => {
  useUpdateDocumentTitle({
    href: '/agency',
    title: 'appHeader.Add New Agency',
    appHeader: 'appHeader.Add New Agency'
  });
  const { t, navigate, enqueueSnackbar } = useQueryHelper();
  const { callCreateAgencyWithUser } = useCreateAgencyWithUserMutation();

  const handleSubmit = async ({
    logo,
    hubspotId,
    countryId,
    companyUrl,
    agencyName,
    phoneNumber,
    advertiserIds,
    internalNetsuiteId,
    hasInvitationEmail,
    ...rest
  }: AgencyFormValues) => {
    try {
      if (rest.type === 'add') {
        await callCreateAgencyWithUser({
          variables: {
            input: {
              name: rest.name,
              email: rest.email,
              countryId,
              agencyName,
              hasInvitationEmail,
              logo: logo || null,
              hubspotId: hubspotId || null,
              companyUrl: companyUrl || null,
              password: rest.password || undefined,
              phoneNumber: phoneNumber || null,
              advertiserIds: advertiserIds.map(Number),
              internalNetsuiteId: internalNetsuiteId || null
            }
          }
        });
      }
      enqueueSnackbar(t('succeededInCreating', { name: agencyName }), { variant: 'success' });
      navigate({ to: '/agency' });
    } catch (error) {
      enqueueSnackbar(t('failedToCreate', { name: agencyName }), { variant: 'error' });
      enqueueSnackbar(t(error.message || UNEXPECTED_ERROR), { variant: 'error' });
    }
  };

  return (
    <div>
      <Header />
      <AgencyForm onSubmit={handleSubmit} />
    </div>
  );
};
